// @NgModule({
//   imports: [
//     CommonModule,
//     RouterModule.forChild([
//       {
//         path: '',
//         pathMatch: 'full',
//         component: StandardizedLoadProfileComponent,
//         resolve: {
//           entity: StandardizedLoadProfileResolver,
//         },
//       },
//     ]),
//     TranslocoModule,

//     FontAwesomeModule,

//     StandardizedLoadProfileFormComponent,
//     StandardizedLoadProfileCheckComponent,
//     StandardizedLoadProfileUploadComponent,

//     ActionButtonModule,

//     PageTileContainerComponent,
//   ],
//   declarations: [StandardizedLoadProfileComponent],
// })
// export class StandardizedLoadProfileModule {}

import { CanDeactivateGuard } from '@clean-code/shared/components/ui-can-deactivate';

export const standardizedLoadProfileRoute = {
  path: 'standardized-load-profile/:id',
  loadComponent: () =>
    import('./standardized-load-profile.component').then(
      (mod) => mod.StandardizedLoadProfileComponent
    ),
  canDeactivate: [CanDeactivateGuard],
  data: {
    translate: 'standardized-load-profile',
  },
  // resolve: {
  //   entity: StandardizedLoadProfileResolver,
  // },
};
